import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output, NgModule, AfterViewInit, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalizationService } from '@services/localization.service';
import { getStatisticPage } from '@environments/environment';

@Component({
  selector: 'statistics',
  templateUrl: '../sharedTemplates/statistics.component.html',
})
export class StatisticsComponent implements OnInit {
  iframe_src;

  constructor(private domSanitizer: DomSanitizer, public _LZ: LocalizationService) {}

  ngOnInit() {
    let url = '';

    url = getStatisticPage(this._LZ.LANGCODE);

    this.iframe_src = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
